import { styled } from "@mui/material/styles";

// Components
import { Link as MLink } from "@mui/material";

export const StyledLink = styled(MLink, { name: "AuthLink" })({
  "&": {
    display: "inline-block",
    textAlign: "right",
    textDecoration: "none",
    height: "30px",
    lineHeight: "30px",
    fontSize: "1.6rem",
    transition: "all 0.3s ease-in",
    ":hover": {
      fontWeight: 500,
    },
  },
});
